import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface PlatformTaxData {
  id: number;
  tax_platform: number;
  checkout_tax: number;
}

export const usePlatformTax = () => {
  const [platformTax, setPlatformTax] = useState<number>(0);
  const [checkoutTax, setCheckoutTax] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlatformTax = async () => {
      try {
        setIsLoading(true);
        
        const { data, error } = await supabase
          .from("tax_checkout")
          .select("tax_platform, checkout_tax")
          .limit(1)
          .maybeSingle();

        if (error) throw error;
        
        const taxValue = Number(data?.tax_platform) || 0;
        const checkoutTaxValue = Number(data?.checkout_tax) || 0;
        setPlatformTax(taxValue);
        setCheckoutTax(checkoutTaxValue);
        
      } catch (err) {
        console.error("Error fetching platform tax:", err);
        setError("Erro ao carregar taxa da plataforma");
        // Fallback para 0 em caso de erro
        setPlatformTax(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlatformTax();
  }, []);

  return {
    platformTax,
    checkoutTax,
    isLoading,
    error
  };
};